import { Component, Input, Output, EventEmitter } from '@angular/core';

import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { Button } from 'primeng/button';
import { Tag } from 'primeng/tag';
import { Tooltip } from 'primeng/tooltip';
import { ProgressSpinner } from 'primeng/progressspinner';
import { TranslateModule } from '@ngx-translate/core';

export interface CheckOutEntry {
  id: string;
  reservationNumber: string;
  guestName: string;
  roomNumber: string;
  checkInDate: string;
  checkOutDate: string;
  checkOutTime: string;
  nights: number;
  totalCharges: number;
  status: 'pending' | 'completed' | 'late';
  paymentStatus: 'paid' | 'pending' | 'partial';
}

@Component({
  selector: 'lib-check-out-table',
  standalone: true,
  imports: [TableModule, Button, Tag, Tooltip, ProgressSpinner, TranslateModule],
  templateUrl: './check-out-table.component.html',
  styleUrls: ['./check-out-table.component.scss'],
})
export class CheckOutTableComponent {
  @Input() checkOuts: CheckOutEntry[] = [];
  @Input() loading = false;
  @Input() totalRecords = 0;
  @Input() first = 0;
  @Input() rows = 20;

  @Output() processCheckOut = new EventEmitter<CheckOutEntry>();
  @Output() viewCharges = new EventEmitter<CheckOutEntry>();
  @Output() requestLateCheckOut = new EventEmitter<CheckOutEntry>();
  @Output() pageChange = new EventEmitter<TableLazyLoadEvent>();

  getStatusSeverity(status: string): 'success' | 'info' | 'warn' | 'danger' {
    const severityMap: Record<string, 'success' | 'info' | 'warn' | 'danger'> = {
      completed: 'success',
      pending: 'warn',
      late: 'danger',
    };
    return severityMap[status] || 'info';
  }

  getPaymentStatusSeverity(status: string): 'success' | 'info' | 'warn' | 'danger' {
    const severityMap: Record<string, 'success' | 'info' | 'warn' | 'danger'> = {
      paid: 'success',
      pending: 'warn',
      partial: 'info',
    };
    return severityMap[status] || 'info';
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
    }).format(amount);
  }

  onProcessCheckOut(entry: CheckOutEntry): void {
    this.processCheckOut.emit(entry);
  }

  onViewCharges(entry: CheckOutEntry): void {
    this.viewCharges.emit(entry);
  }

  onRequestLateCheckOut(entry: CheckOutEntry): void {
    this.requestLateCheckOut.emit(entry);
  }

  onPageChange(event: TableLazyLoadEvent): void {
    this.pageChange.emit(event);
  }
}
